/**
 * Conmutador de tema (sol/luna). El predeterminado es el claro y ya viene escrito en
 * <html>; public/theme-init.js aplica el oscuro antes del primer pintado si se eligió. Aquí
 * solo se cambia, se recuerda y se mantienen al día la etiqueta y el título del botón, que
 * dicen qué se gana con el cambio (estándar §1.2).
 */
const CLAVE = "vutbooking-tema";

export function iniciarTema(): void {
  const botones = document.querySelectorAll<HTMLButtonElement>("[data-tema]");
  if (!botones.length) return;
  const raiz = document.documentElement;

  const rotular = () => {
    const oscuro = !raiz.classList.contains("theme-light");
    botones.forEach((b) => {
      b.setAttribute("aria-label", oscuro ? "Cambiar a tema claro" : "Cambiar a tema oscuro");
      b.title = oscuro
        ? "Tema claro: el aspecto por defecto de VutBooking"
        : "Tema oscuro: menos brillo en entornos con poca luz";
    });
  };

  rotular();
  botones.forEach((boton) =>
    boton.addEventListener("click", () => {
      const claro = raiz.classList.toggle("theme-light");
      try {
        localStorage.setItem(CLAVE, claro ? "light" : "dark");
      } catch {
        /* almacenamiento bloqueado: el tema durará solo esta visita */
      }
      rotular();
    }),
  );
}
